export default "__VITE_ASSET__DGIKUKTY__"